import { Observable } from 'rxjs'
import { ToasterService } from '../../../features/notification/toaster.service'
import { first } from 'rxjs/operators'
import { RecurrenceEditingMode } from '../../../features/recurrence/recurrenceEditing'
import { RruleHelper } from '../../../features/recurrence/rruleHelper'
import { RecurrentFeathersModel } from '../../../models/RecurrentFeathersModel'
import { DateRange, DateUtils } from '../../date-utils.service'
import { addMinutes, differenceInMinutes, subDays } from 'date-fns'

export abstract class RecurrenceService {
  allStream$: Observable<RecurrentFeathersModel[]>
  TAG: string

  constructor(public toaster: ToasterService) {}

  abstract create(recurrable: RecurrentFeathersModel, propsToCreateFrom: any): Promise<RecurrentFeathersModel>
  abstract updateNonRecurrently(recurrable: RecurrentFeathersModel): Promise<RecurrentFeathersModel>
  abstract queryFeathers(query: {}): Observable<RecurrentFeathersModel[]>
  abstract queryFeathersPromise(query: {}): Promise<RecurrentFeathersModel[]>

  async update(
    recurrable: RecurrentFeathersModel,
    mode: RecurrenceEditingMode = RecurrenceEditingMode.none,
    propsToUpdateWith?: RecurrentFeathersModel,
  ) {
    console.log(this.TAG, 'update')
    const clone: RecurrentFeathersModel = recurrable.shallowClone()
    propsToUpdateWith = clone.updateFromProps(propsToUpdateWith)

    if (!recurrable.isRecurrent() && mode === RecurrenceEditingMode.none) {
      if (!!propsToUpdateWith) {
        return await this.updateNonRecurrently(recurrable.updateFromProps(propsToUpdateWith))
      }
      return await this.updateNonRecurrently(recurrable)
    }
    return await this.updateRecurrent(recurrable, mode, propsToUpdateWith)
  }

  // TODO: REMOVE
  private async updateRecurrent(
    oldRecurrable: RecurrentFeathersModel,
    mode: RecurrenceEditingMode,
    newRecurrable: RecurrentFeathersModel,
  ): Promise<RecurrentFeathersModel> {
    console.log(
      'updateRecurrentRecurrentFeathersModel',
      RecurrenceEditingMode[RecurrenceEditingMode[mode]],
      oldRecurrable,
      newRecurrable,
    )
    console.log(`updateRecurrent parentId from child: ${oldRecurrable.recurrenceParentId}`)

    if (mode === RecurrenceEditingMode.none) {
      mode = RecurrenceEditingMode.currentOccurrence
    }

    console.log('old rrule', oldRecurrable.rrule)

    let parent: RecurrentFeathersModel
    if (oldRecurrable.recurrenceParentId) {
      console.log(`updateRecurrent parentId from child right before getParent: ${oldRecurrable.recurrenceParentId}`)
      // parent = await firstValueFrom(this.getParent(oldRecurrable))
      parent = await this.getParentPromise(oldRecurrable)
      console.log(
        `updateRecurrent parentId of parent after get: ${parent.id}, should be ${oldRecurrable.recurrenceParentId}`,
      )
      console.log('getting parent', parent)
    } else if (oldRecurrable.isFirstInRecurrentSeries()) {
      parent = oldRecurrable.shallowClone()
    }

    if (!parent) {
      console.log('no parent available')
      return this.updateNonRecurrently(oldRecurrable.updateFromProps(newRecurrable))
    }

    console.log('end', parent.recurrenceEnd)

    switch (mode) {
      case RecurrenceEditingMode.currentOccurrence:
        if (this.isAnException(parent, oldRecurrable)) {
          console.log(
            this.TAG,
            'updateRecurrent(), is an exception',
            parent.recurrenceException,
            newRecurrable.getDateFrom(),
          )
          console.log(
            this.TAG,
            'updateRecurrent(), isoDate',
            RruleHelper.isoDateToIcal(newRecurrable.getDateFrom().toISOString()),
          )
          if (
            RruleHelper.recurrenceExceptionListContains(
              parent.recurrenceException,
              new Date(newRecurrable.getDateFrom()),
            )
          ) {
            console.log(
              this.TAG,
              "updateRecurrent(), parent contains this recurrence exception (ie. plannedFrom hasn't changed",
            )
            return this.updateNonRecurrently(oldRecurrable.updateFromPropsToCreateRecurrenceException(newRecurrable))
          }
          console.log(
            this.TAG,
            "updateRecurrent(), parent NOT contains this recurrence exception - plannedFrom has changed. We don't do anything as the exception needs to stay in the same place.",
          )
          return this.updateNonRecurrently(oldRecurrable.updateFromPropsToCreateRecurrenceException(newRecurrable))
        } else {
          console.log('is not an exception')
          if (this.isFirstInRecurrentSeries(oldRecurrable, parent)) {
            newRecurrable.recurrenceParentId = parent.id
          }

          // if (updating) {
          parent.recurrenceException = RruleHelper.generateRecurrenceExceptionForParent(
            oldRecurrable.getDateFrom(),
            parent.getDateFrom(),
            parent.recurrenceException,
          )
          newRecurrable.rrule = null
          newRecurrable.recurrenceException = null
          await this.updateNonRecurrently(parent)
          return this.create(oldRecurrable, newRecurrable)
          // }
          // if (removing) {
          //   return this.updateNonRecurrently(parent)
          // }
        }
      case RecurrenceEditingMode.currentOccurrenceAndFollowing:
        console.log('currentAndFollowing')
        console.log('recurrenceParentID', oldRecurrable.recurrenceParentId, oldRecurrable.id)
        console.log('new AssistanceIIDS', newRecurrable.recurrenceParentId, newRecurrable.id)
        console.log('objects', oldRecurrable, newRecurrable, parent)
        console.log('recurrenceParentID', !!oldRecurrable.recurrenceParentId)

        if (!!oldRecurrable.recurrenceParentId) {
          if (this.isAnException(parent, oldRecurrable)) {
            console.log('is an exception')
            console.log('end', parent.recurrenceEnd)
            // a > if this occurrence is an exception, "this+future" edit is only possible if it's the last exception.
            if (RruleHelper.isLastExceptionOrLater(parent.recurrenceException, new Date(oldRecurrable.getDateFrom()))) {
              parent.recurrenceException = RruleHelper.removeRecurrenceException(
                parent.recurrenceException,
                new Date(oldRecurrable.getDateFrom()),
              )
              console.log('end', parent.recurrenceEnd)

              const endDate = new Date(newRecurrable.getDateFrom())
              endDate.setHours(0)
              endDate.setMinutes(0)
              parent.rrule = RruleHelper.changeRruleEndDate(parent.rrule, new Date(parent.getDateFrom()), endDate)
              newRecurrable.rrule = RruleHelper.changeRruleEndDate(
                parent.rrule,
                new Date(newRecurrable.getDateFrom()),
                RruleHelper.extractUntilDateFromStringRrule(parent.rrule),
              )

              newRecurrable.recurrenceParentId = null
              await this.updateNonRecurrently(parent)
              // - update this Assistance (rrule would be taken from the form)
              return this.updateNonRecurrently(oldRecurrable.updateFromProps(newRecurrable))
            }
            this.toaster.simpleToast('Not the last exception in series, editing not supported.')
            console.warn('Not the last exception in series, editing not supported.')
          } else {
            console.log('is not an exception')
            // Is not yet a RecurrenceException
            if (this.isFirstInRecurrentSeries(oldRecurrable, parent)) {
              newRecurrable.recurrenceException = parent.recurrenceException
              newRecurrable.recurrenceParentId = null
              return this.updateNonRecurrently(oldRecurrable.updateFromProps(newRecurrable))
            }
            // b > if this occurrence doesn't have exception (ID), we need to create new recurrenceID, assign it to this record
            // - save this Occurrence as Assistance to get new ID, with new props
            const newParent = await this.create(oldRecurrable, newRecurrable)
            // - first, check all exceptions in the parent and split them by date of this record. Older ones stay with the oldAA parent, new ones go to this RException
            // Exceptions for the new parent should also have shifted times to accommodate potential startDate change on the parent (otherwise we'll be expanding events that were previously changed/removed)
            const splitExceptions = RruleHelper.splitRecurrenceExceptionsByDateAndShift(
              parent.recurrenceException,
              new Date(newParent.getDateFrom()),
              parent.getDateFrom(),
              newParent.getDateFrom(),
            )
            parent.recurrenceException = splitExceptions.older
            newParent.recurrenceException = splitExceptions.newer
            // - delete RecurrenceParentId from this occurrence
            newParent.recurrenceParentId = null

            const newParentEndDate = new Date(parent.recurrenceEnd)
            // newParentEndDate.setHours(0)
            // newParentEndDate.setMinutes(0)
            newParent.rrule = RruleHelper.changeRruleEndDate(
              parent.rrule,
              new Date(newParent.getDateFrom()),
              newParentEndDate,
            )
            // - go through all exceptions for this new series, change their parentId to new one (excluding this occurrence)
            const series: RecurrentFeathersModel[] = await this.getAvailabilitiesByParentIdAndRecurrenceException(
              parent.id,
              newParent.recurrenceException,
            )
            for (const aa of series) {
              aa.recurrenceParentId = newParent.id
              await this.updateNonRecurrently(aa)
            }
            // Change the oldAA parent's end date to end before the split
            const oldParentEndDate = subDays(new Date(newParent.getDateFrom()), 1)
            oldParentEndDate.setHours(
              parent.getDateFrom().getHours(),
              parent.getDateFrom().getMinutes(),
              parent.getDateFrom().getSeconds(),
            )

            parent.rrule = RruleHelper.changeRruleEndDate(
              parent.rrule,
              new Date(parent.getDateFrom()),
              oldParentEndDate,
            )
            await this.updateNonRecurrently(parent)
            return this.updateNonRecurrently(newParent)
          }
        } else {
          if (RruleHelper.isRecurrentFeathersModelFirstInSeries(oldRecurrable, new Date(parent.getDateFrom()))) {
            console.log(this.TAG, 'Updating assistance - first in series')
            return this.updateNonRecurrently(oldRecurrable.updateFromProps(newRecurrable))
          } else {
            console.error('no parent ID, not first - if this is called, investigate')
            // TODO: the code below may never get called!!!
            // b > if this occurrence doesn't have exception (ID), we need to create new recurrenceID, assign it to this record
            // - save this Occurrence as Assistance to get new ID, with new props
            const newParent = await this.create(oldRecurrable, newRecurrable)
            // - first, check all exceptions in the parent and split them by date of this record. Older ones stay with the oldAA parent, new ones go to this RException
            const splitExceptions = RruleHelper.splitRecurrenceExceptionsByDateAndShift(
              parent.recurrenceException,
              newParent.getDateFrom(),
              parent.getDateFrom(),
              newParent.getDateFrom(),
            )
            parent.recurrenceException = splitExceptions.older
            newParent.recurrenceException = splitExceptions.newer
            // - delete RecurrenceParentId from this occurrence
            newParent.recurrenceParentId = null
            // - go through all exceptions for this new series, change their parentId to new one (excluding this occurrence)
            const series: RecurrentFeathersModel[] = await this.getAvailabilitiesByParentIdAndRecurrenceException(
              parent.id,
              newParent.recurrenceException,
            )
            for (const assistance of series) {
              assistance.recurrenceParentId = newParent.id
              await this.updateNonRecurrently(assistance)
            }
            const endDate = new Date(newParent.getDateFrom())
            endDate.setMinutes(new Date(newParent.getDateFrom()).getMinutes() - 1)
            parent.rrule = RruleHelper.changeRruleEndDate(parent.rrule, new Date(parent.getDateFrom()), endDate)
            // Save parent
            await this.updateNonRecurrently(parent)
            // Save this occurrence
            return this.updateNonRecurrently(newParent)
          }
        }
        break
      case RecurrenceEditingMode.allOccurrences:
        // This is not allowed.
        console.error('Editing all occurrences is not supported.')
        return null

      default:
        return null
    }
  }

  public async getParentPromise(recurrable: RecurrentFeathersModel): Promise<RecurrentFeathersModel> {
    if (recurrable.isFirstInRecurrentSeries()) {
      return recurrable
    } else {
      return (
        await this.queryFeathersPromise({
          id: recurrable.recurrenceParentId,
        })
      )[0]
    }
  }

  private async getAvailabilitiesByParentIdAndRecurrenceException(id: number, recurrenceExceptionList: string) {
    const records: RecurrentFeathersModel[] = await this.queryFeathers({
      recurrenceParentId: id,
    })
      .pipe(first())
      .toPromise()

    return records.filter((a) => {
      return RruleHelper.recurrenceExceptionListContains(recurrenceExceptionList, new Date(a.getDateFrom()))
    })
  }

  isAnException(parent: RecurrentFeathersModel, occurrence: RecurrentFeathersModel) {
    // An occurrence is an exception when it has a parentId different from its own
    if (occurrence.recurrenceParentId && occurrence.id && parent.id) {
      return occurrence.recurrenceParentId !== occurrence.id && occurrence.recurrenceParentId === parent.id
    }
    return false
  }

  private isFirstInRecurrentSeries(occurrence: RecurrentFeathersModel, parent: RecurrentFeathersModel) {
    return occurrence.getDateFrom().getTime() === parent.getDateFrom().getTime()
  }

  async initRecurrenceEndIfCreatingException(recurrable: RecurrentFeathersModel, mode: RecurrenceEditingMode) {
    console.log('initRecurrenceEndIfCreatingException', recurrable.rrule, mode)
    if (mode === RecurrenceEditingMode.currentOccurrenceAndFollowing) {
      const parent: RecurrentFeathersModel = await this.getParentPromise(recurrable)
      recurrable.rrule = RruleHelper.changeRruleEndDate(
        recurrable.rrule,
        recurrable.getDateFrom(),
        RruleHelper.extractUntilDateFromStringRrule(parent.rrule),
      )
      console.log('initRecurrenceEndIfCreatingException changed', recurrable.rrule, parent.recurrenceEnd)
    }
    console.log('initRecurrenceEndIfCreatingException', recurrable.rrule)
    return recurrable.rrule
  }

  /**
   * Given a range and a recurrence parent, this function checks whether the range would be inside the recurrence parent's range (between dateFrom and dateTo)
   * if they were occurring at the same date. So it effectively just compares the times.
   * This functions takes into consideration the case where the parent and/or the range span over midnight.
   * @param parent
   * @param range
   */
  static isTimeRangeInsideRecurrenceParentTimeRegardlessOfDate(parent: RecurrentFeathersModel, range: DateRange) {
    const parentHhmmStart = DateUtils.getMilitaryTime(parent.getDateFrom())
    const parentHhmmEnd = DateUtils.getMilitaryTime(parent.getDateTo())
    const parentDurationMinutes = differenceInMinutes(parent.getDateTo(), parent.getDateFrom())

    // 1. set range start date to the same date as parent start date (keep time unchanged)
    range.from.setFullYear(
      parent.getDateFrom().getFullYear(),
      parent.getDateFrom().getMonth(),
      parent.getDateFrom().getDate(),
    )

    // 2. set range end to shifted range start plus duration in minutes
    range.to = addMinutes(new Date(range.from), parentDurationMinutes)

    // 3. If military time end is smaller than start, it means the parent is going over midnight. We need to add 1 day to the tested range.
    if (parentHhmmEnd < parentHhmmStart) range = DateUtils.addDaysToDateRange(range, 1)

    // 4. check if range is inside parent range
    const parentRange: DateRange = {
      from: parent.getDateFrom(),
      to: parent.getDateTo(),
    }

    return DateUtils.isInRange(range.from, parentRange) && DateUtils.isInRange(range.to, parentRange)
  }
}
